import { Divider, HStack, VStack } from "@gluestack-ui/themed";
import { Icon } from "@repo/core/components/core/Icon";
import { Text } from "@repo/core/components/core/Text";
import {
  TransactionItemInfoByStatus,
  TransactionItemInfoByType
} from "./utils";
import { TransactionItemProps } from "./types";
import {
  TransactionItemStatusEnum,
  TransactionItemTypeEnum,
  typeOfInstallment
} from "@repo/core/constants/transactions";
import { numberToBrl } from "@repo/core/utils/currency.utils";

export const TransactionItem = ({
  strTipo,
  dblValor,
  intTipoParcelamento,
  strNomePortador,
  strSituacao,
  showDivider
}: TransactionItemProps) => {
  const { paymentName, icon } = strTipo
    ? TransactionItemInfoByType[strTipo]
    : TransactionItemInfoByType[TransactionItemTypeEnum.COMPRA];

  const { statusColor, showStatus, statusName } = strSituacao
    ? TransactionItemInfoByStatus[strSituacao]
    : TransactionItemInfoByStatus[TransactionItemStatusEnum.ATIVO];

  const purchaseName = intTipoParcelamento
    ? typeOfInstallment[intTipoParcelamento]
    : paymentName;

  return (
    <>
      <VStack>
        <HStack gap="$2">
          <VStack alignItems="center" justifyContent="center">
            <Icon name={icon} color={statusColor} variant="solid" size={28} />
          </VStack>
          <VStack flex={1} space="xs">
            <Text
              fontWeight={500}
              fontSize="$2xs"
              color="$textLight700"
              numberOfLines={1}
            >
              {strTipo === TransactionItemTypeEnum.COMPRA
                ? purchaseName
                : paymentName}
            </Text>
            <Text
              fontWeight={500}
              fontSize="$xs"
              color="$textLight800"
              numberOfLines={1}
            >
              {strNomePortador}
            </Text>
          </VStack>
          <VStack alignItems="flex-end" justifyContent="flex-end">
            {showStatus && (
              <Text fontWeight={500} fontSize="$xs" color={statusColor}>
                {statusName}
              </Text>
            )}
            <Text
              fontWeight={600}
              fontSize="$sm"
              strikeThrough={
                strSituacao === TransactionItemStatusEnum.CANCELADO
              }
            >
              {numberToBrl(dblValor || 0)}
            </Text>
          </VStack>
        </HStack>
      </VStack>
      {showDivider ? <Divider my="$4" /> : null}
    </>
  );
};
